
module.exports = function() {
  return function formatTime(input) {
    const date = moment.utc(input);
    return date.isValid() ? date.format("LT") : "";
  };
}